import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const language = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/i18n/{profile}/language',
    app: 'i18n',
    pk: 'code'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'i18n', model: 'language' }
    ),
    { }
  )
)()

export { language, TYPES }
